import i18next from 'i18next';

import { dataSourceTypes, frequencyTypes, globalStockingParameter, stockingParameterTypes, weightUnits, weightUnitsByCompany } from '../../../config/commons';

import { CompanyStockingParameter } from './interfaces';

export const getKeysStockingParameterCustom = (props: { companyStockingParameters: CompanyStockingParameter[]; fields: string[] }) => {
  const { companyStockingParameters, fields } = props;
  const companyStockingParametersFiltered = companyStockingParameters.filter(element => element.type === stockingParameterTypes.NUMERIC);

  const keysSelected = companyStockingParametersFiltered.filter(element => fields.includes(element.key));
  const otherKeys = companyStockingParametersFiltered.filter(element => !fields.includes(element.key));

  return {
    keysSelected,
    otherKeys,
  };
};

export const getFrequencyType = (props: { options: string[]; frequencyType?: string }) => {
  const { frequencyType, options } = props;

  if (options.length <= 1) {
    return frequencyTypes.INDIVIDUAL;
  }

  return frequencyType || frequencyTypes.INDIVIDUAL;
};

export const getAggregationMethod = (props: { options: string[]; frequencyType?: string; aggregationMethod?: string }) => {
  const { frequencyType, options, aggregationMethod } = props;

  if (options.length <= 1 || frequencyType === frequencyTypes.INDIVIDUAL) {
    return undefined;
  }

  return aggregationMethod;
};

export const disabledForm = (props: { parameterType?: string; options: string[]; aggregationMethod?: string; frequencyType?: string; stockingParameter?: string; minimum?: number; maximum?: number; isAutomatic?: boolean }) => {
  const { parameterType, options, aggregationMethod, frequencyType, stockingParameter, minimum, maximum, isAutomatic } = props;

  if (isAutomatic) {
    const isValid = !!stockingParameter;
    return !isValid;
  }

  switch (parameterType) {
    case stockingParameterTypes.CATEGORICAL:
      return !(!!stockingParameter && options.length > 0);

    case stockingParameterTypes.NUMERIC: {
      const isValid = (!!stockingParameter && ((minimum !== undefined) && minimum >= 0) && (maximum && maximum > minimum));
      if (options.length <= 1) {
        return !isValid;
      }

      if (!frequencyType) {
        return true;
      }

      if (frequencyType === frequencyTypes.INDIVIDUAL) {
        return !isValid;
      }

      return !(isValid && !!aggregationMethod);
    }

    default:
      return true;
  }
};

export const getParameterLabelByKey = (key: string) => {
  const label = `parameters.${key}`;
  const translation = i18next.t(label);
  const isCustomParameter = translation === label;
  return isCustomParameter ? key : i18next.t(label);
};

export const getParameterDefaultUnit = (params: { stockingParameter: string; companyWeightUnit: string; defaultUnit?: string }) => {
  const { stockingParameter, companyWeightUnit, defaultUnit } = params;

  switch (stockingParameter) {
    case globalStockingParameter.BIOMASS:
      if (companyWeightUnit === weightUnitsByCompany.KILOGRAM) {
        return weightUnits.KG;
      }

      if (companyWeightUnit === weightUnitsByCompany.POUND) {
        return weightUnits.LB;
      }

      return '';
    
    default:
      return defaultUnit;
  }
};

export const filterAutomaticCompanyParameters = (params: { companyStockingParameters: CompanyStockingParameter[] }) => {
  const { companyStockingParameters } = params;
  return companyStockingParameters.filter(item => item.dataSource === dataSourceTypes.AUTOMATIC || item.dataSource === dataSourceTypes.API);
};

export const getIsAutomaticLabel = (key: string) => {
  switch (key) {
    case globalStockingParameter.BIOMASS:
      return i18next.t('stockingParameter.form.isAutomaticInfo.biomass');

    case globalStockingParameter.ACCUMULATED_FEED:
    default:
      return i18next.t('stockingParameter.form.isAutomaticInfo.default');
      break;
  }
};
